module.exports = __webpack_public_path__ + "static/media/polygonActive.74b2abb9.png";